module.exports = __webpack_public_path__ + "static/media/Close.5583236d.svg";